export type LangKey =
  | 'pageTitle'
  | 'breadcrumb.configurations'
  | 'breadcrumb.perfectTruck'
  | 'tabs.equipment'
  | 'tabs.photos'
  | 'tabs.routes'
  | 'tabs.loadSequences'
  | 'info.photoBanner'
  | 'info.routeBanner'
  | 'info.loadSequenceBanner'
  | 'infoBanner'
  | 'searchPlaceholder'
  | 'addButton.equipment'
  | 'addButton.photo'
  | 'addButton.route'
  | 'addButton.loadSequence'
  | 'table.equipmentName'
  | 'table.certifierPos'
  | 'table.certifierNeg'
  | 'table.checkerPos'
  | 'table.checkerNeg'
  | 'modal.addTitle'
  | 'modal.editTitle'
  | 'button.cancel'
  | 'button.save'
  | 'button.saveChanges'
  | 'validation.completeTranslations'
  | 'toast.addSuccess'
  | 'toast.updateSuccess'
  | 'toast.addSuccess.photo'
  | 'toast.updateSuccess.photo'
  | 'toast.addSuccess.route'
  | 'toast.updateSuccess.route'
  | 'toast.addSuccess.loadSequence'
  | 'toast.updateSuccess.loadSequence'
  | 'pagination.rowsPerPage'
  | 'pagination.page'
  | 'pagination.of'
  | 'pagination.first'
  | 'pagination.previous'
  | 'pagination.next'
  | 'pagination.last'
  | 'lastUpdated.last'
  | 'lastUpdated.by'
  | 'lastUpdated.on'
  | 'lastUpdated.at'
  | 'table.certifier'
  | 'table.checker'
  | 'table.order'
  | 'table.duo'
  | 'table.fsv'
  | 'table.route'
  | 'table.org'
  | 'table.3pl'
  | 'table.whd'
  | 'table.active'
  | 'label.yes'
  | 'label.no'
  | 'counts.active'
  | 'counts.inactive'
  | 'table.photoLabel'
  | 'table.displayOrder'
  | 'table.routeType'
  | 'table.deliveryType'
  | 'table.loadSequence'
  | 'form.equipmentName'
  | 'form.certifierPosLabel'
  | 'form.certifierNegLabel'
  | 'form.checkerPosLabel'
  | 'form.checkerNegLabel'
  | 'form.showOnCertifier'
  | 'form.showOnChecker'
  | 'form.displayOrder'
  | 'form.duo'
  | 'form.fsv'
  | 'form.routeType'
  | 'form.orgType'
  | 'form.3plStatus'
  | 'form.whdStatus'
  | 'form.active'
  | 'form.textField'
  | 'form.textFieldHint'
  | 'form.deliveryType'
  | 'placeholder.example'
  | 'placeholder.selectOrg'
  | 'placeholder.selectDeliveryType'
  | 'validation.routeTypeRequired'
  | 'validation.routeTypeLengthExceed'
  | 'validation.routeTypeExists'
  | 'validation.deliveryTypeRequired'
  | 'validation.routeTypeAlreadyExists'
  | 'validation.atLeastOneActive'
  | 'modal.addTitle.photo'
  | 'modal.editTitle.photo'
  | 'modal.addTitle.route'
  | 'modal.editTitle.route'
  | 'modal.addTitle.loadSequence'
  | 'modal.editTitle.loadSequence'
  | 'modal.unsavedTitle'
  | 'modal.unsaved.continue'
  | 'modal.unsaved.close'
  | 'modal.unsaved.message'
  | 'form.routeTypeName'
  | 'form.loadSequenceValue'
  | 'pagination.of'
  | 'lastUpdated.last'
  | 'lastUpdated.by'
  | 'lastUpdated.on'
  | 'lastUpdated.at';

const TRANSLATIONS: Record<string, Record<LangKey, string>> = {
  en: {
    pageTitle: 'Perfect Truck',
    'breadcrumb.configurations': 'Configurations',
    'breadcrumb.perfectTruck': 'Perfect Truck',
    'tabs.equipment': 'Equipment Items',
    'tabs.photos': 'Photo Categories',
    'tabs.routes': 'Route Types',
    'tabs.loadSequences': 'Load Sequences',
    infoBanner: '"Truck Plugged In / Jack Charging" is a system-level item that always appears first on the certifier form. It is not configurable and does not appear here.',
    searchPlaceholder: 'Search equipment...',
    'addButton.equipment': '+ Add Equipment Item',
    'addButton.photo': '+ Add Photo Category',
    'addButton.route': '+ Add Route Type',
    'addButton.loadSequence': '+ Add Load Sequence',
    'table.equipmentName': 'Equipment Name',
    'table.certifierPos': 'Cert +',
    'table.certifierNeg': 'Cert −',
    'table.checkerPos': 'Check +',
    'table.checkerNeg': 'Check −',
    'table.certifier': 'Certifier',
    'table.checker': 'Checker',
    'table.order': 'Order',
    'table.duo': 'DUO',
    'table.fsv': 'FSV',
    'table.route': 'Route',
    'table.org': 'Org',
    'table.3pl': '3PL',
    'table.whd': 'WHD',
    'table.active': 'Active',
    'label.yes': 'Yes',
    'label.no': 'No',
    'counts.active': 'Active',
    'counts.inactive': 'Inactive',
    'table.photoLabel': 'Photo Label',
    'table.displayOrder': 'Display Order',
    'table.routeType': 'Route Type',
    'table.deliveryType': 'Delivery Type',
    'table.loadSequence': 'Load Sequence',
    'info.photoBanner': 'Maximum of 6 active photo categories allowed per configuration. On mobile, more than 3 active categories wrap to a second row.',
    'info.routeBanner': 'At least one Route Type must remain active. Items cannot be deleted, only deactivated.',
    'info.loadSequenceBanner': 'At least one Load Sequence must remain active. Items cannot be deleted, only deactivated.',
    'modal.addTitle': 'Add Equipment Item',
    'modal.editTitle': 'Edit Equipment Item',
    'button.cancel': 'Cancel',
    'button.save': 'Save',
    'button.saveChanges': 'Save Changes',
    'validation.completeTranslations': 'Please complete translations for all languages before saving.',
    'toast.addSuccess': 'Equipment item added successfully.',
    'toast.updateSuccess': 'Equipment item updated successfully.',
    'toast.addSuccess.photo': 'Photo category added successfully.',
    'toast.updateSuccess.photo': 'Photo category updated successfully.',
    'toast.addSuccess.route': 'Route type added successfully.',
    'toast.updateSuccess.route': 'Route type updated successfully.',
    'toast.addSuccess.loadSequence': 'Load sequence added successfully.',
    'toast.updateSuccess.loadSequence': 'Load sequence updated successfully.',
    'pagination.rowsPerPage': 'Rows per page',
    'pagination.page': 'Page',
    'pagination.first': 'First page',
    'pagination.previous': 'Previous page',
    'pagination.next': 'Next page',
    'pagination.last': 'Last page',
    'pagination.of': 'of',
    'lastUpdated.last': 'Last updated',
    'lastUpdated.by': 'by',
    'lastUpdated.on': 'on',
    'lastUpdated.at': 'at',
    'form.equipmentName': 'Equipment Name / Question',
    'form.certifierPosLabel': 'Certifier Positive Label',
    'form.certifierNegLabel': 'Certifier Negative Label',
    'form.checkerPosLabel': 'Checker Positive Label',
    'form.checkerNegLabel': 'Checker Negative Label',
    'form.showOnCertifier': 'Show on Certifier Form',
    'form.showOnChecker': 'Show on Checker Form',
    'form.displayOrder': 'Display Order',
    'form.duo': 'DUO Equipment',
    'form.fsv': 'FSV Equipment',
    'form.routeType': 'Route Type',
    'form.orgType': 'Org Type',
    'form.3plStatus': '3PL Status',
    'form.whdStatus': 'WHD Status',
    'form.active': 'Active',
    'form.textField': 'Text Field',
    'form.textFieldHint': '(No by default)',
    'form.deliveryType': 'Delivery Type',
    'placeholder.example': 'e.g. Wedge-its',
    'placeholder.selectOrg': 'Select org...',
    'placeholder.selectDeliveryType': 'Select Delivery Type',
    'validation.routeTypeRequired': 'Route type name is required.',
    'validation.routeTypeLengthExceed': 'Route type name cannot exceed 50 characters.',
    'validation.routeTypeExists': '"{{routeType}}" already exists.',
    'validation.deliveryTypeRequired': 'Delivery type is required.',
    'validation.routeTypeAlreadyExists': 'Route Type Already Exists',
    'validation.atLeastOneActive': 'At least one route type must remain active.',
    'modal.addTitle.photo': 'Add Photo Category',
    'modal.editTitle.photo': 'Edit Photo Category',
    'modal.addTitle.route': 'Add Route Type',
    'modal.editTitle.route': 'Edit Route Type',
    'modal.addTitle.loadSequence': 'Add Load Sequence',
    'modal.editTitle.loadSequence': 'Edit Load Sequence',
    'modal.unsavedTitle': 'You have unsaved changes',
    'modal.unsaved.continue': 'Continue Editing',
    'modal.unsaved.close': 'Close',
    'modal.unsaved.message': 'Are you sure you want to close without saving?',
    'form.routeTypeName': 'Route Type Name',
    'form.loadSequenceValue': 'Load Sequence Value',
  },
  fr: {
    pageTitle: 'Camion Parfait',
    'breadcrumb.configurations': 'Configurations',
    'breadcrumb.perfectTruck': 'Camion Parfait',
    'tabs.equipment': "Éléments d'équipement",
    'tabs.photos': 'Catégories de photos',
    'tabs.routes': 'Types d’itinéraire',
    'tabs.loadSequences': 'Séquences de chargement',
    infoBanner: '"Camion branché / Chargeur de cric" est un élément système qui apparaît toujours en premier dans le formulaire de certificateur. Il n’est pas configurable et n’apparaît pas ici.',
    searchPlaceholder: 'Rechercher l’équipement...',
    'addButton.equipment': '+ Ajouter un élément',
    'addButton.photo': '+ Ajouter une catégorie de photo',
    'addButton.route': '+ Ajouter un type d’itinéraire',
    'addButton.loadSequence': '+ Ajouter une séquence de chargement',
    'table.equipmentName': "Nom de l'équipement",
    'table.certifierPos': 'Cert +',
    'table.certifierNeg': 'Cert −',
    'table.checkerPos': 'Vérif +',
    'table.checkerNeg': 'Vérif −',
    'table.certifier': 'Certificateur',
    'table.checker': 'Vérificateur',
    'table.order': 'Ordre',
    'table.duo': 'DUO',
    'table.fsv': 'FSV',
    'table.route': 'Itinéraire',
    'table.org': 'Org',
    'table.3pl': '3PL',
    'table.whd': 'WHD',
    'table.active': 'Actif',
    'label.yes': 'Oui',
    'label.no': 'Non',
    'counts.active': 'Actif',
    'counts.inactive': 'Inactif',
    'table.photoLabel': 'Libellé de photo',
    'table.displayOrder': 'Ordre d’affichage',
    'table.routeType': 'Type d’itinéraire',    'table.deliveryType': 'Type de livraison',    'table.loadSequence': 'Séquence de chargement',
    'info.photoBanner': 'Maximum de 6 catégories de photos actives par configuration. Sur mobile, plus de 3 catégories actives passent à une deuxième ligne.',
    'info.routeBanner': 'Au moins un type d’itinéraire doit rester actif. Les éléments ne peuvent pas être supprimés, seulement désactivés.',
    'info.loadSequenceBanner': 'Au moins une séquence de chargement doit rester active. Les éléments ne peuvent pas être supprimés, seulement désactivés.',
    'modal.addTitle': "Ajouter un élément d'équipement",
    'modal.editTitle': "Modifier l'élément d'équipement",
    'button.cancel': 'Annuler',
    'button.save': 'Enregistrer',
    'button.saveChanges': 'Enregistrer les modifications',
    'validation.completeTranslations': 'Veuillez compléter les traductions pour toutes les langues avant d’enregistrer.',
    'toast.addSuccess': "L'élément a été ajouté avec succès.",
    'toast.updateSuccess': "L'élément a été mis à jour avec succès.",
    'toast.addSuccess.photo': 'Catégorie de photo ajoutée avec succès.',
    'toast.updateSuccess.photo': 'Catégorie de photo modifiée avec succès.',
    'toast.addSuccess.route': 'Type d’itinéraire ajouté avec succès.',
    'toast.updateSuccess.route': 'Type d’itinéraire modifié avec succès.',
    'toast.addSuccess.loadSequence': 'Séquence de chargement ajoutée avec succès.',
    'toast.updateSuccess.loadSequence': 'Séquence de chargement modifiée avec succès.',
    'pagination.rowsPerPage': 'Lignes par page',
    'pagination.page': 'Page',
    'pagination.first': 'Première page',
    'pagination.previous': 'Page précédente',
    'pagination.next': 'Page suivante',
    'pagination.last': 'Dernière page',
    'pagination.of': 'de',
    'lastUpdated.last': 'Dernière mise à jour',
    'lastUpdated.by': 'par',
    'lastUpdated.on': 'le',
    'lastUpdated.at': 'à',
    'form.equipmentName': "Nom de l'équipement / Question",
    'form.certifierPosLabel': 'Libellé positif du certificateur',
    'form.certifierNegLabel': 'Libellé négatif du certificateur',
    'form.checkerPosLabel': 'Libellé positif du vérificateur',
    'form.checkerNegLabel': 'Libellé négatif du vérificateur',
    'form.showOnCertifier': 'Afficher sur le formulaire du certificateur',
    'form.showOnChecker': 'Afficher sur le formulaire du vérificateur',
    'form.displayOrder': 'Ordre d’affichage',
    'form.duo': 'Équipement DUO',
    'form.fsv': 'Équipement FSV',
    'form.routeType': "Type d’itinéraire",
    'form.orgType': 'Type d’organisation',
    'form.3plStatus': 'Statut 3PL',
    'form.whdStatus': 'Statut WHD',
    'form.active': 'Actif',
    'form.textField': 'Champ de texte',
    'form.textFieldHint': '(Non par défaut)',
    'form.deliveryType': 'Type de livraison',
    'placeholder.example': 'ex. Wedge-its',
    'placeholder.selectOrg': 'Sélectionner org...',
    'placeholder.selectDeliveryType': 'Sélectionner le type de livraison',
    'validation.routeTypeRequired': 'Le nom du type d\'itinéraire est obligatoire.',
    'validation.routeTypeLengthExceed': 'Le nom du type d\'itinéraire ne peut pas dépasser 50 caractères.',
    'validation.routeTypeExists': '« {{routeType}} » existe déjà.',
    'validation.deliveryTypeRequired': 'Le type de livraison est obligatoire.',
    'validation.routeTypeAlreadyExists': 'Le type d\'itinéraire existe déjà',
    'validation.atLeastOneActive': 'Au moins un type d\'itinéraire doit rester actif.',
    'modal.addTitle.photo': 'Ajouter une catégorie de photo',
    'modal.editTitle.photo': "Modifier la catégorie de photo",
    'modal.addTitle.route': "Ajouter un type d’itinéraire",
    'modal.editTitle.route': "Modifier le type d’itinéraire",
    'modal.addTitle.loadSequence': 'Ajouter une séquence de chargement',
    'modal.editTitle.loadSequence': 'Modifier la séquence de chargement',
    'modal.unsavedTitle': "Vous avez des modifications non enregistrées",
    'modal.unsaved.continue': 'Continuer la modification',
    'modal.unsaved.close': 'Fermer',
    'modal.unsaved.message': "Êtes-vous sûr de vouloir fermer sans enregistrer ?",
    'form.routeTypeName': 'Nom du type d’itinéraire',
    'form.loadSequenceValue': 'Valeur de la séquence de chargement',
  },
  es: {
    pageTitle: 'Camión Perfecto',
    'breadcrumb.configurations': 'Configuraciones',
    'breadcrumb.perfectTruck': 'Camión Perfecto',
    'tabs.equipment': 'Elementos de equipo',
    'tabs.photos': 'Categorías de fotos',
    'tabs.routes': 'Tipos de ruta',
    'tabs.loadSequences': 'Secuencias de carga',
    infoBanner: '"Camión enchufado / Carga del gato" es un elemento del sistema que siempre aparece primero en el formulario del certificador. No es configurable y no aparece aquí.',
    searchPlaceholder: 'Buscar equipo...',
    'addButton.equipment': '+ Agregar elemento',
    'addButton.photo': '+ Agregar categoría de foto',
    'addButton.route': '+ Agregar tipo de ruta',
    'addButton.loadSequence': '+ Agregar secuencia de carga',
    'table.equipmentName': 'Nombre del equipo',
    'table.certifierPos': 'Cert +',
    'table.certifierNeg': 'Cert −',
    'table.checkerPos': 'Verif +',
    'table.checkerNeg': 'Verif −',
    'table.certifier': 'Certificador',
    'table.checker': 'Verificador',
    'table.order': 'Orden',
    'table.duo': 'DUO',
    'table.fsv': 'FSV',
    'table.route': 'Ruta',
    'table.org': 'Org',
    'table.3pl': '3PL',
    'table.whd': 'WHD',
    'table.active': 'Activo',
    'label.yes': 'Sí',
    'label.no': 'No',
    'counts.active': 'Activo',
    'counts.inactive': 'Inactivo',
    'table.photoLabel': 'Etiqueta de foto',
    'table.displayOrder': 'Orden de visualización',
    'table.routeType': 'Tipo de ruta',
    'table.deliveryType': 'Tipo de entrega',
    'table.loadSequence': 'Secuencia de carga',
    'info.photoBanner': 'Máximo de 6 categorías de fotos activas por configuración. En móvil, más de 3 categorías activas pasan a una segunda fila.',
    'info.routeBanner': 'Al menos un Tipo de Ruta debe permanecer activo. Los elementos no se pueden eliminar, solo desactivar.',
    'info.loadSequenceBanner': 'Al menos una Secuencia de Carga debe permanecer activa. Los elementos no se pueden eliminar, solo desactivar.',
    'modal.addTitle': 'Agregar elemento de equipo',
    'modal.editTitle': 'Editar elemento de equipo',
    'button.cancel': 'Cancelar',
    'button.save': 'Guardar',
    'button.saveChanges': 'Guardar cambios',
    'validation.completeTranslations': 'Complete las traducciones para todos los idiomas antes de guardar.',
    'toast.addSuccess': 'Elemento agregado con éxito.',
    'toast.updateSuccess': 'Elemento actualizado con éxito.',
    'toast.addSuccess.photo': 'Categoría de foto agregada con éxito.',
    'toast.updateSuccess.photo': 'Categoría de foto actualizada con éxito.',
    'toast.addSuccess.route': 'Tipo de ruta agregado con éxito.',
    'toast.updateSuccess.route': 'Tipo de ruta actualizado con éxito.',
    'toast.addSuccess.loadSequence': 'Secuencia de carga agregada con éxito.',
    'toast.updateSuccess.loadSequence': 'Secuencia de carga actualizada con éxito.',
    'pagination.rowsPerPage': 'Filas por página',
    'pagination.page': 'Página',
    'pagination.first': 'Primera página',
    'pagination.previous': 'Página anterior',
    'pagination.next': 'Página siguiente',
    'pagination.last': 'Última página',
    'pagination.of': 'de',
    'lastUpdated.last': 'Última actualización',
    'lastUpdated.by': 'por',
    'lastUpdated.on': 'el',
    'lastUpdated.at': 'a las',
    'form.equipmentName': 'Nombre del equipo / Pregunta',
    'form.certifierPosLabel': 'Etiqueta positiva del certificador',
    'form.certifierNegLabel': 'Etiqueta negativa del certificador',
    'form.checkerPosLabel': 'Etiqueta positiva del verificador',
    'form.checkerNegLabel': 'Etiqueta negativa del verificador',
    'form.showOnCertifier': 'Mostrar en el formulario del certificador',
    'form.showOnChecker': 'Mostrar en el formulario del verificador',
    'form.displayOrder': 'Orden de visualización',
    'form.duo': 'Equipo DUO',
    'form.fsv': 'Equipo FSV',
    'form.routeType': 'Tipo de ruta',
    'form.orgType': 'Tipo de organización',
    'form.3plStatus': 'Estado 3PL',
    'form.whdStatus': 'Estado WHD',
    'form.active': 'Activo',
    'form.textField': 'Campo de texto',
    'form.textFieldHint': '(No por defecto)',
    'form.deliveryType': 'Tipo de entrega',
    'placeholder.example': 'p.ej. Wedge-its',
    'placeholder.selectOrg': 'Seleccionar org...',
    'placeholder.selectDeliveryType': 'Seleccionar tipo de entrega',
    'validation.routeTypeRequired': 'El nombre del tipo de ruta es obligatorio.',
    'validation.routeTypeLengthExceed': 'El nombre del tipo de ruta no puede exceder 50 caracteres.',
    'validation.routeTypeExists': '"{{routeType}}" ya existe.',
    'validation.deliveryTypeRequired': 'El tipo de entrega es obligatorio.',
    'validation.routeTypeAlreadyExists': 'El tipo de ruta ya existe',
    'validation.atLeastOneActive': 'Al menos un tipo de ruta debe permanecer activo.',
    'modal.addTitle.photo': 'Agregar categoría de foto',
    'modal.editTitle.photo': 'Editar categoría de foto',
    'modal.addTitle.route': 'Agregar tipo de ruta',
    'modal.editTitle.route': 'Editar tipo de ruta',
    'modal.addTitle.loadSequence': 'Agregar secuencia de carga',
    'modal.editTitle.loadSequence': 'Editar secuencia de carga',
    'modal.unsavedTitle': 'Tienes cambios sin guardar',
    'modal.unsaved.continue': 'Continuar editando',
    'modal.unsaved.close': 'Cerrar',
    'modal.unsaved.message': '¿Seguro que quieres cerrar sin guardar?',
    'form.routeTypeName': 'Nombre del tipo de ruta',
    'form.loadSequenceValue': 'Valor de la secuencia de carga',
  },
};

export const t = (lang: string | undefined, key: LangKey) => {
  const l = (lang && TRANSLATIONS[lang]) ? lang : 'en';
  return TRANSLATIONS[l][key] ?? TRANSLATIONS.en[key];
};

export default TRANSLATIONS;
